// Manual brand palette — single source of truth, no circular deps
export const MP = {
  deepBlue:   '#0d1b4b',
  blue:       '#1a237e',
  black:      '#0a0a0a',
  darkBg:     '#111827',
  cardBg:     '#1a2744',
  green:      '#1b5e20',
  greenMid:   '#2e7d32',
  greenLight: '#43a047',
  yellow:     '#f9a825',
  yellowMid:  '#fbc02d',
  white:      '#ffffff',
  offWhite:   '#f0f2f8',
  textLight:  '#e8eaf6',
  textMuted:  '#9fa8da',
  border:     'rgba(255,255,255,0.1)',
};
